import React, { useState } from 'react';
import { cx } from 'linaria';
import { mobileHeaderStyle } from './MobileHeader.style';

import { LinkEvaluator, useModalManagement, CTA } from 'r3-lib/dist/r3lib';
import { useHistory } from 'react-router-dom';

import { SVG } from '../../../../assets/SVG';
import { StyledSearchBar } from '../../SearchBar/SearchBar';
import { FlyoutTrigger } from '../../../ui/Flyout/FlyoutTrigger';
import { FlyoutMenuLayout } from '../../../ui/Flyout/FlyoutMenuLayout';
import { SearchResult } from '../../SearchResult/SearchResult';
import { FlyoutCartLayout } from '../../../ui/Flyout/FlyoutCartLayout';
import Badge from '../../../ui/Badge';
import loadable from '@loadable/component';
import LoadingPage from '../../../LoadingPage';
import { campaignbarComponents } from '../../../ContentEditor/ContentComponents';
import { DynamicCategoryRenderer } from '../../../ContentEditor/DynamicCategoryRenderer/DynamicCategoryRenderer';
import { Link } from 'react-router-dom';
import t, { useIntl } from '@jetshop/intl';
import { StyledHeaderDropdown } from '../HeaderDropdown/HeaderDropdown';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { headerDropdowCategoryStyle } from '../HeaderDropdownCategory/HeaderDropdownCategory.style';
import { searchResultDesktopStyle } from '../DesktopHeader/DesktopHeader.style';
import { ClickToClose } from '../DesktopHeader/DesktopHeader.style';

export const LoadableFlyout = loadable(
  () => import('../../../ui/Flyout/Flyout'),
  {
    fallback: <LoadingPage />,
    resolveComponent: Flyout => Flyout.Flyout
  }
);

const parentsToString = parents => {
  if (!parents || parents.length === 0) return '';
  let sortedParents =
    parents.length > 1
      ? [...parents].sort((a, b) => {
          if (a.id.length < b.id.length) {
            return -1;
          } else {
            return 1;
          }
        })
      : parents;
  return (
    sortedParents
      ?.map(parent => parent?.object?.breadcrumbText ?? [])
      .join(' > ') + ' > '
  );
};

const getHighlightedText = (text, highlight) => {
  // Split on higlight term and include term into parts, ignore case
  const parts = text.split(
    new RegExp(
      `(${escapeRegExp(highlight)
        .split(' ')
        .join('|')})`,
      'gi'
    )
  );

  const highlightArray = highlight.split(' ');
  const toHighlightLower = highlightArray?.map(word => word.toLowerCase());
  return parts.reduce((prev, curr, index) => {
    return [
      ...prev,
      toHighlightLower.includes(curr.toLowerCase()) ? (
        <strong
          style={{
            fontWeight: 600
          }}
          key={index}
        >
          {curr}
        </strong>
      ) : (
        curr
      )
    ];
  }, []);
};

const escapeRegExp = string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const MobileHeader = ({
  categories,
  favouritesCount,
  routes,
  cartData,
  style
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState();

  const translate = useIntl();
  const history = useHistory();

  const { closeAll } = useModalManagement();
  const { result, cart } = cartData;

  const searchPlaceholderString = translate(
    'Search for product or category...'
  );

  const handleMenuClose = () => {
    closeAll();
    // setSearchValue('');
    setActiveCategory(false);
    setMenuOpen(false);
  };

  return (
    <div className={cx('mobile-header', style)}>
      <DynamicCategoryRenderer
        categoryId={process?.env?.REACT_APP_CAMPAIGNBAR_CATEGORY_ID}
        rendererComponents={campaignbarComponents}
      />

      <div className={cx('logo-and-icons')}>
        <div className="left">
          <LinkEvaluator
            linkClickCallback={() => {
              closeAll();
            }}
            link={'/'}
          >
            <SVG name={process?.env?.REACT_APP_LOGO_NAME} className={'logo'} />
          </LinkEvaluator>
        </div>
        <div className="right">
          {/* <HeaderChannelSelector /> */}
          <LinkEvaluator
            linkClickCallback={() => {
              closeAll();
            }}
            link={'/inkopslista'}
          >
            <div style={{ position: 'relative' }}>
              <SVG name={'Heart'} />
              <Badge text={favouritesCount} />
            </div>
          </LinkEvaluator>
          <FlyoutTrigger triggerId={'header-cart-mobile'}>
            {drawer => (
              <div style={{ position: 'relative' }}>
                <SVG
                  name={'Cart'}
                  className={'cart'}
                  onClick={() => {
                    drawer.isOpen ? drawer.hideTarget() : drawer.showTarget();
                  }}
                />
                <Badge text={cart?.totalQuantity} />
              </div>
            )}
          </FlyoutTrigger>
          <FlyoutTrigger triggerId={'header-menu-mobile'}>
            {drawer => (
              <SVG
                name={'Menu'}
                onClick={() => {
                  drawer.isOpen ? drawer.hideTarget() : drawer.showTarget();
                }}
              />
            )}
          </FlyoutTrigger>
        </div>
      </div>
      <div className="header-search">
        <StyledSearchBar
          placeholder={searchPlaceholderString}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          keyActions={{
            Escape: () => {
              console.log('ESC button action triggered');
            },
            Enter: () => {
              console.log('ENTER button action triggered');

              history?.push(`${routes?.search?.path}/?term=${searchValue}`);
              setSearchValue('');
            }
          }}
          onFocus={() => {
            setMenuOpen(false);
            handleMenuClose();
            closeAll();
          }}
          onClick={() => {
            setMenuOpen(false);
            handleMenuClose();
            closeAll();
          }}
        />
      </div>
      {searchValue?.length >= 3 && (
        <>
          <SearchResult searchValue={searchValue}>
            {searchResult => {
              const autoComplete = searchResult?.data?.searchAutoComplete;
              setSearchOpen(!!autoComplete);
              return (
                <StyledHeaderDropdown open={searchOpen} setOpen={setSearchOpen}>
                  <div
                    className={cx('search-result', searchResultDesktopStyle)}
                  >
                    {searchResult?.loading ? (
                      'loading..' // TODO - Add loader
                    ) : (
                      <div className={cx('results', 'mobile')}>
                        <div className="left mobile">
                          <div
                            className={cx(
                              'categories',
                              headerDropdowCategoryStyle
                            )}
                          >
                            <Link
                              to={`${routes?.search?.path}/?term=${searchValue}`}
                              onClick={() => {
                                setSearchValue('');
                              }}
                              className="search-title-mobile"
                            >
                              {/* TODO- Check translation */}
                              {t('Search suggestions')}
                            </Link>
                            {autoComplete?.categories?.result?.length > 0 && (
                              <h4>{t('Categories')}</h4>
                            )}

                            {autoComplete?.categories?.result?.map(
                              (cat, index) => {
                                const displayText =
                                  parentsToString(cat?.primaryRoute?.parents) +
                                  cat?.name;
                                return (
                                  <div
                                    className="search-result-link"
                                    onClick={() => {
                                      setSearchValue('');
                                    }}
                                    key={index + '-auto-complete-' + cat.id}
                                  >
                                    <CategoryLink category={cat}>
                                      {getHighlightedText(
                                        cat?.name,
                                        searchValue
                                      )}
                                    </CategoryLink>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </StyledHeaderDropdown>
              );
            }}
          </SearchResult>
          {searchValue && (
            <ClickToClose
              onClick={() => setSearchValue('')}
              style={{ zIndex: -1 }}
            />
          )}
        </>
      )}

      <LoadableFlyout targetId={'header-menu-mobile'} left={true}>
        {drawer => (
          <FlyoutMenuLayout
            categories={categories}
            active={true}
            parent={null}
            routes={routes}
            close={drawer.hideTarget}
          />
        )}
      </LoadableFlyout>
      <LoadableFlyout targetId={'header-cart-mobile'} right={true}>
        {drawer => (
          <>
            <FlyoutCartLayout
              close={drawer.hideTarget}
              result={result}
              cart={cart}
            />
          </>
        )}
      </LoadableFlyout>
    </div>
  );
};

export const StyledMobileHeader = ({
  categories,
  favouritesCount,
  routes,
  cartData
}) => {
  return (
    <MobileHeader
      categories={categories}
      routes={routes}
      cartData={cartData}
      style={mobileHeaderStyle}
      favouritesCount={favouritesCount}
    />
  );
};
